// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import letterRegistrationEntity from './entities/letter-registration.json';
import letterRegistrationMenu from '../pages/letter-registration/menu.json';
import letterRegistrationFullForm from '../pages/letter-registration/forms/full.json';
import letterRegistrationContextForm from '../pages/letter-registration/forms/context.json';
import letterRegistrationMiniForm from '../pages/letter-registration/forms/mini.json';
import letterRegistrationLookupForm from '../pages/letter-registration/forms/lookup.json';
import letterRegistrationTableView from '../pages/letter-registration/views/table.json';
import letterRegistrationCardsView from '../pages/letter-registration/views/cards.json';
import letterRegistrationCalendarView from '../pages/letter-registration/views/calendar.json';
import letterRegistrationDashboardView from '../pages/letter-registration/views/dashboard.json';

/** Тип запису «Реєстрація листа» зі сторінками пакета: меню, форми та подання з pages/letter-registration/. */
export const letterRegistrationDefinition: IRecordTypeDefinition = {
  ...letterRegistrationEntity,
  views: assembleViewSet({
      table: letterRegistrationTableView,
      cards: letterRegistrationCardsView,
      calendar: letterRegistrationCalendarView,
      dashboard: letterRegistrationDashboardView,
  }),
  form: letterRegistrationFullForm,
  forms: { full: letterRegistrationFullForm, context: letterRegistrationContextForm, mini: letterRegistrationMiniForm, lookup: letterRegistrationLookupForm },
  menu: letterRegistrationMenu,
} as IRecordTypeDefinition;
